import React, {Component, ReactNode} from 'react';
import I18n from 'app/i18n';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import {isDesktop} from 'app/utils';

interface Props {
    buyIn: () => void
    disabled: boolean
}

export default class PokerMenuButtonRebuy extends Component<Props> {
    onClick = (e: React.MouseEvent<HTMLButtonElement>): void => {
        e.preventDefault();

        this.props.buyIn();
    };

    render(): ReactNode {
        return <button
            className="poker-menu-container-button rebuy"
            onClick={this.onClick}
            disabled={this.props.disabled}
        >
            <SpriteIcon name="#svg-rebuy-icon" className="svg-default"/>
            {isDesktop() && <span className="name">{I18n.t('poker.bet_rebuy')}</span>}
        </button>;
    }
}
